module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-informations",
    class: {
      'segment-infos': _vm.isSegmentMode
    },
    attrs: {
      "id": "list-informations"
    }
  }, [(_vm.isSegmentMode && Object.keys(_vm.segment).length !== 0) ? _c('div', {
    staticStyle: {
      "width": "250px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showpop),
      expression: "showpop"
    }],
    staticClass: "info-pop cnqr-popover",
    staticStyle: {
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.showpop = false
      }
    }
  }, [_c('b-row', {
    staticClass: "content text-m"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('panels.infos.name_segment')) + "\n        " + _vm._s(_vm.segment.title) + "\n      ")]), _vm._v(" "), _c('b-row', {
    staticClass: "content  text-m content__duration"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('panels.infos.duration_total')) + "\n        " + _vm._s(_vm._f("FormatTime")(_vm.totalDurationScreens)) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-info-c",
    on: {
      "click": function($event) {
        _vm.showpop = !_vm.showpop
      }
    }
  }, [_c('span', {
    staticClass: "mr-2 fa fa-info-circle"
  }), _vm._v(_vm._s(_vm.$t('panels.infos.title')) + "\n    ")])]) : _vm._e(), _vm._v(" "), (!_vm.isSegmentMode && Object.keys(_vm.template).length !== 0) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showpop),
      expression: "showpop"
    }],
    staticClass: "info-pop cnqr-popover arrow top info-pop-3",
    staticStyle: {
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.showpop = false
      }
    }
  }, [_c('b-row', {
    staticClass: " text-m content"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('panels.infos.name_template')) + "\n        " + _vm._s(_vm.template.title) + "\n      ")]), _vm._v(" "), _c('b-row', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('initialize_duration_template_action'),
      expression: "'initialize_duration_template_action'"
    }],
    staticClass: "content text-m content__duration"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('panels.infos.duration_template')) + "\n        "), (_vm.isEditMode) ? _c('span', [_vm._v(" " + _vm._s(_vm.Getduration(_vm.template.duration)))]) : _c('span', [_vm._v(" " + _vm._s(_vm.template.duration))])]), _vm._v(" "), (_vm.paramsClient.default_segment_duration !== null) ? _c('b-row', {
    staticClass: "content content__duration text-m "
  }, [_vm._v("\n        " + _vm._s(_vm.$t('panels.infos.duration_total')) + "\n        " + _vm._s(_vm._f("FormatTime")((_vm.totalDurationSegments - 2))) + "\n      ")]) : _c('b-row', {
    staticClass: "content content__duration text-m "
  }, [_vm._v("\n        " + _vm._s(_vm.$t('panels.infos.duration_total')) + "\n        " + _vm._s(_vm._f("FormatTime")((_vm.totalDurationSegments))) + "\n      ")]), _vm._v(" "), _c('b-row', {
    staticClass: "content content__duration text-m"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('panels.infos.size_template')) + " " + _vm._s(_vm.canvasSize.width) + " x " + _vm._s(_vm.canvasSize.height) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-info-c",
    on: {
      "click": function($event) {
        _vm.showpop = !_vm.showpop
      }
    }
  }, [_c('span', {
    staticClass: "mr-2 fa fa-info-circle"
  }), _vm._v(_vm._s(_vm.$t('panels.infos.title')) + "\n    ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6abfaa86","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Informations.vue
// module id = 841
// module chunks = 1 3